import React, { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "@/assets/dinamo-logo.svg";
import GlobalSVGDefs from "../Shared/GlobalSVGDefs";
import { useMe } from "@/context/MeContext";
import "./Layout.css";

interface UnauthenticatedLayoutProps {
  children: ReactNode;
}

const UnauthenticatedLayout: React.FC<UnauthenticatedLayoutProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const { me } = useMe();

  const goToLogin = () => {
    navigate("/login");
  };

  useEffect(() => {
    if (me) {
      navigate(me.type === "ADMIN" ? "/admin/analytics" : "/catalogue");
    }
  });

  return (
    <>
      <GlobalSVGDefs />
      <nav className="header">
        <div
          className="flex gap-3 items-center cursor-pointer "
          onClick={goToLogin}
        >
          <Logo />
          <div className="text-[#004a99] text-base font-bold">
            Digitalne revije
          </div>
        </div>
      </nav>
      <div className="unauthenticated scroll-container">{children}</div>
    </>
  );
};

export default UnauthenticatedLayout;
